export class ColorSource {
    constructor() {
        this.distinctColors = [
            '#FF88BB',
            '#BBDD44',
            '#AAAAAA',
            '#22CCFF',
            '#884499',
            '#FF8822',
            '#FFDD00',
            '#EE4488',
            '#884433',
            '#0077BB',
            '#44BB55',
            '#DD2222',
        ];
    }
    nextWithOpacity(opacity) {
        return this.nextColor() + Math.trunc(opacity * 255).toString(16);
    }
    releaseColor(color) {
        this.distinctColors.push(color.slice(0, 7));
    }
    nextColor() {
        return this.distinctColors.pop();
    }
}
